import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    modal: {
      backgroundColor: theme.modal.item,
    },
    container: {
      padding: `${spacing.m}px ${spacing.s}px`,
      backgroundColor: theme.card.background,
      borderRadius: constants.radius.view,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      userSelect: "none",
      cursor: "pointer",
    },
    content: {
      marginLeft: spacing.s,
      marginRight: spacing.s,
      flexDirection: "column",
      flexGrow: 1,
    },

    title: {
      fontSize: 14,
    },
    subtitle: {
      fontSize: 12,
      color: theme.text.secondary,
    },
  };

  return styles;
};
